module.exports = __webpack_public_path__ + "img/zh1.ff763321.png";